import React from 'react';

export default function Flex({className = '', children, style = {}, direction = 'row', shrink = null, ...rest}) {
    var style = {
        ...style, 
        display: 'flex', 
        flexDirection: direction
    };

    if(shrink !== null) {
        var style = {...style, flexShrink: shrink};
    }

    return (
        <div 
            {...rest}
            className={`c3-flex ${className}`} 
            style={style}>
                {children}
        </div>
    );
}


// WEBPACK FOOTER //
// ./app/c3/flex/Flex.js